import Vue from 'vue';

export class ResponseErrorsInterceptor {
  static resolve(response) {
    const data = response.data;
    if (typeof data.result !== 'undefined' && data.result === false) {
      const errors =
        typeof data.message !== 'undefined'
          ? [data.message]
          : Object.entries(data.errors).reduce(
              (acc, [, error]) => [...acc, error],
              []
            );
      return Promise.reject(errors);
    }
    return response;
  }
  static reject(error) {
    if (error.response.status === 404) {
      return Promise.reject(error);
    }
    const title = `${error.response.statusText} (${error.response.status})`;
    const message = error.response.data.message || error.response.statusText;
    const vm = new Vue();
    vm.$bvToast.toast(message, {
      title,
      autoHideDelay: 7000,
      variant: 'danger'
    });
    return Promise.reject(error);
  }
}
